import { AGGREGATE_RATING, ORGANIZATION_NAME, SITE_URL } from './constants';

export function buildOrganizationSchema(): Record<string, any> {
  return {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: ORGANIZATION_NAME,
    url: SITE_URL,
    logo: `${SITE_URL}/icons/icon-512x512.png`,
    description:
      'Melbourne\u2019s best mobile personal trainers - male & female trainers near you. One-on-one personal training, group sessions, nutrition coaching & NDIS support. Prices from $99/week. We come to you.',
    telephone: '1800446464',
    email: 'info@getgoingpt.com.au',
    address: {
      '@type': 'PostalAddress',
      addressLocality: 'Melbourne',
      addressRegion: 'VIC',
      addressCountry: 'AU',
    },
    contactPoint: {
      '@type': 'ContactPoint',
      telephone: '+61-1800-446-464',
      contactType: 'customer service',
      areaServed: 'AU',
      availableLanguage: 'English',
    },
    sameAs: [
      'https://www.facebook.com/GetGoingPT',
      'https://www.instagram.com/getgoingpt/',
      'https://www.linkedin.com/company/get-going-pt/',
    ],
    aggregateRating: {
      '@type': 'AggregateRating',
      ...AGGREGATE_RATING,
    },
  };
}
